module.exports = __webpack_public_path__ + "static/media/athenaslogo.87a44a14.png";